import $ from 'jquery';
import { isIE9 } from './Utils';

export default class WaypointContoller {
    constructor(elem) {
        this.ANIMATION_CLASS = isIE9() ? 'fadeInUpNoAnimation' : 'fadeInUp';
        this.OFFSET = '90%';
        this.doAnimations(elem, this.ANIMATION_CLASS);
    }

    doAnimations(elem, animationClass) {
        new Waypoint({ // eslint-disable-line no-undef
            element: elem,
            handler() {
                $(this.element).toggleClass('animated');
                $(this.element).toggleClass(animationClass);
                this.destroy();
            },
            offset: this.OFFSET,
            group: 'waypoint-group',
        });
    }


    static init() {
        $(document).ready(() => {
            $('main .webzone-wrapper:not(.no-csstransitions) > div').each((index, elem) => {
                new WaypointContoller(elem); // eslint-disable-line no-new
            });
        });
    }
}
